var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "reg-pop-wrap",
    class: {
      mb: _vm.mb
    }
  }, [_c('div', {
    staticClass: "toast"
  }), _vm._v(" "), _c('div', {
    staticClass: "txt-wrap"
  }, [_c('div', {
    staticClass: "reg-content"
  }, [_vm._v("\n            " + _vm._s(_vm.txt) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function click($event) {
        return _vm.clickPop();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.ok'))))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };